module.exports = __webpack_public_path__ + "bd.svg?e5a2a6355e041abfe96c07b66a87b2f8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bd.svg
// module id = 752
// module chunks = 27